import { useState, useEffect } from 'react';
import { getHelsenorgeUrl, getTjenesterUrl } from '@helsenorge/framework-utils/hn-proxy-service';
import { warn } from '@helsenorge/framework-utils/logger';
/**
 * URL som skal brukes som retururl i brødsmulestien. Både retururl og retururltekst må være definert.
 *
 * retururl kan være en absolutt URL, men må da være en URL til www.helsenorge.no eller tjenester.helsenorge.no,
 * og må bruke http/https som protokoll.
 *
 * Dersom retururl er relativ, vil den bli prefikset med tjenester.helsenorge.no.
 */
export const RETURURL_PARAM = 'retururl';
/**
 * Tekst som skal brukes sammen med retururl i brødsmulestien. Både retururl og retururltekst må være definert.
 */
export const RETURURLTEKST_PARAM = 'retururltekst';
const ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);
/**
 * Sjekk om URL peker til en tillatt host og at URLen bruker http eller https som protokoll.
 */
const isAllowedReturUrl = (url, allowedHosts) => ALLOWED_PROTOCOLS.has(url.protocol) && allowedHosts.has(url.hostname);
export const useReturUrl = () => {
    const [returUrl, setReturUrl] = useState();
    useEffect(() => {
        const rawHelsenorgeUrl = getHelsenorgeUrl();
        const rawTjenesterUrl = getTjenesterUrl();
        if (!rawHelsenorgeUrl || !rawTjenesterUrl) {
            // Dersom brødsmulestien brukes utenfor våre domener, vil vi ikke kunne finne riktig retururl
            return;
        }
        const helsenorgeUrl = new URL(rawHelsenorgeUrl);
        const tjenesterUrl = new URL(rawTjenesterUrl);
        const allowedHosts = new Set([helsenorgeUrl.hostname, tjenesterUrl.hostname]);
        const params = new URLSearchParams(window.location.search);
        const lowercaseParams = new URLSearchParams();
        params.forEach((value, key) => {
            lowercaseParams.set(key.toLowerCase(), value);
        });
        const rawReturUrl = lowercaseParams.get(RETURURL_PARAM);
        const rawReturUrlTekst = lowercaseParams.get(RETURURLTEKST_PARAM);
        if (!rawReturUrl || !rawReturUrlTekst) {
            return;
        }
        try {
            // Bruk tjenester.helsenorge.no som base for relative URLer, og for å validere at kun tillatte URLer brukes som retururl.
            const url = new URL(rawReturUrl, tjenesterUrl);
            if (isAllowedReturUrl(url, allowedHosts)) {
                // eslint-disable-next-line react-hooks/set-state-in-effect -- @todo vurder om dette kan fikses
                setReturUrl({ returUrl: url.toString(), returUrlTekst: rawReturUrlTekst });
            }
            else {
                warn(`Ikke en tillatt URL: ${rawReturUrl}`);
            }
        }
        catch (e) {
            warn(`Ikke en gyldig URL: ${rawReturUrl}`, e);
        }
    }, []);
    return returUrl;
};
